import { menus } from '@/agent';

const actions = {
	async fetchMainMenu({ commit }) {
		const menu = await menus.get();
		commit('setMainMenu', { menu });
	},


	setFooterLinks({ commit }, { privacyLink, imprintLink }) {
		commit('setFooterLinks', { privacyLink, imprintLink });
	},

	/**
	 * Due we use the same codebase for all cities we need to make some color modifications in
	 * some cases.
	 * Theme providers in this repository should only use the theme provided from store.
	 * @param {Object} commit - vuex commit method
	 * @param {Object} theme - theme variables
	 */
	setTheme({ commit }, { primaryColor, secondaryColor, logoUrl }) {
		commit('setTheme', { primaryColor, secondaryColor, logoUrl });
	},
};

export { actions as default };
